import React from 'react';
import './CollectEffect.css';

function CollectEffect({ x, y, size, color = '#00ffa3' }) {
    // Position the effect exactly where the tile is
    const containerStyle = {
        left: `${x}px`,
        top: `${y}px`,
        width: `${size}px`,
        height: `${size}px`,
    };

    return (
        <div className="collect-effect" style={containerStyle}>
            <div className="collect-ring" style={{borderColor: color}}></div>
        </div>
    );
}

export default CollectEffect;